import { Context } from "@nuxt/types";

import Api from "@/utils/api";

interface GetCollectionsParams {
  id?: string;
  userId?: string;
}

interface GetCollectionWishesParams extends GetCollectionsParams {
  limit?: number;
  cursor?: string;
}

// example hash: MTFlYi02MzBmLWMxZjAxMDI4LWE2MzEtMDI0MmFjMTEwMDA0OjM1N2YxYTUzNGRiZTRlZTk4OGMxOWI4OTE0NDNjOTc2
const DEFAULT_SHARED_WISHLIST_LIMIT = 30;

export default class WishlistsApi extends Api {
  readonly url = "/v2";

  constructor($axios: Context["$axios"]) {
    super("contentFavoritesService", $axios);
  }

  async getSharedCollections({ id, userId }: GetCollectionsParams) {
    const collectionId = id ?? "";
    return await this.request<OneCollectionResponse>({
      method: "GET",
      url: `${this.url}/wish_collections_shared/${collectionId}`,
      params: {
        user_id: userId,
      },
    });
  }

  async getSharedCollectionWishes({
    id,
    userId,
    limit = DEFAULT_SHARED_WISHLIST_LIMIT,
    cursor,
  }: GetCollectionWishesParams) {
    const collectionId = id ?? "";
    return await this.request<ManyWishesResponse>({
      method: "GET",
      url: `${this.url}/wish_collections_shared/${collectionId}/wishes`,
      params: {
        user_id: userId,
        limit,
        cursor,
      },
    });
  }
}
